import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import KnowledgeBasePage from "./pages/KnowledgeBasePage";
import HelpPage from "./pages/HelpPage";
import AuthMagic from "./pages/AuthMagic";

/**
 * IPMI Library — standalone deployment for ai.ipmi.org.
 *
 * One product, one product only. The /ipmi-ai paths from the old
 * combined deployment redirect to root for backward compatibility
 * with any saved bookmarks.
 */
function App() {
  React.useEffect(() => {
    document.title = 'IPMI Library — Members-only Intelligence';
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<KnowledgeBasePage />} />
          <Route path="/help" element={<HelpPage />} />

          {/* Magic-link sign-in landing — consumes the token */}
          <Route path="/auth/magic" element={<AuthMagic />} />

          {/* Legacy paths from ipmi50th.com/ipmi-ai — redirect for old bookmarks */}
          <Route path="/ipmi-ai" element={<Navigate to="/" replace />} />
          <Route path="/ipmi-ai/help" element={<Navigate to="/help" replace />} />

          {/* Catch-all → home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
